import { render, staticRenderFns } from "./InitDialog.vue?vue&type=template&id=2d18cb1a&scoped=true"
import script from "./InitDialog.vue?vue&type=script&lang=js"
export * from "./InitDialog.vue?vue&type=script&lang=js"
import style0 from "./InitDialog.vue?vue&type=style&index=0&id=2d18cb1a&prod&scoped=true&lang=css"
import style1 from "./InitDialog.vue?vue&type=style&index=1&id=2d18cb1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d18cb1a",
  null
  
)

export default component.exports